import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

const Layout = () => {
  return (
    <>
      <AppNavbar />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
